import React from "react";
import SubjectTimelineComponent from "./SubjectTimeline.component";
import { useParams } from "react-router-dom";

const SubjectTimelineContainer = (props: any) => {
    const { subject } = useParams();

    return <SubjectTimelineComponent
        subject={subject}
    />;
};

export default SubjectTimelineContainer;